import request from '@/axios'
export function fetchPieChart (customer_id) {
  return request({
    url :`graph/pieChart/${customer_id}`,
    method:'POST'
  })
}

export function fetchXAxisFieldApi (platform_module_id) {
  return request({
    url :`graph/xAxis/${platform_module_id}`,
    method:'GET'
  })
}
export function fetchYAxisFieldApi (platform_module_id, xAxisId) {
  return request({
    url :`graph/yAxis/${platform_module_id}/${xAxisId}`,
    method:'GET'
  })
}

export function barLineAreaGraphApi (customer_id, payload) {
  return request({
    url :`graph/barDiagram/${customer_id}`,
    method:'POST',
    data:payload
  })
}
export function saveGraphApi (customer_id, payload) {
  return request({
    url :`graph/create/${customer_id}`,
    method:'POST',
    data:payload
  })
}
export function listSaveGraphApi (customer_id, payload) {
  return request({
    url :`graph/list/${customer_id}`,
    method:'POST',
    data:payload
  })
}

export function getGeneratedSavedApi (customer_id, graph_id) {
  return request({
    url :`graph/generate/saved/${customer_id}/${graph_id}`,
    method:'GET'
  })
}

export function platformModuleslistApi () {
  const customer_id = localStorage.getItem('customer_id')
  return request({
    url: `/graph/platformModuleList/${customer_id}`,
    method: 'GET'
  })
}
export function deleteGraphApi (customer_id, graph_id) {
  
  return request({
    url: `graph/delete/${customer_id}/${graph_id}`,
    method: 'GET'
  })
}
 
export function updateGraphApi (customer_id, graph_id, payload) {
  return request({
    url: `graph/update/${customer_id}/${graph_id}`,
    method: 'POST',
    data: payload
  })
}
